import ArchiveIcon from '@mui/icons-material/Archive';
import CodeIcon from '@mui/icons-material/Code';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderIcon from '@mui/icons-material/Folder';
import GavelIcon from '@mui/icons-material/Gavel';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import WorkIcon from '@mui/icons-material/Work';
import {
  Avatar,
  Box,
  CssBaseline,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

function AppBarComponent() {
  const { user } = useAuth();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TroubleshootIcon sx={{ mr: 2, ml: 2 }} />
        <Typography variant="h6" component={Link} to="/" sx={{ fontFamily: 'Montserrat', color: 'inherit' }}>
          ANALYZER
        </Typography>
      </Box>
      <IconButton size="large">
        <Avatar alt={user?.name} src={user?.picture} />
      </IconButton>
    </Box>
  );
}

const menuItems = [
  { text: 'Home', icon: <HomeIcon />, path: '/' },
  { text: 'Projects', icon: <FolderIcon />, path: '/projects' },
  { text: 'Incidents', icon: <ArchiveIcon />, path: '/incidents' },
  { text: 'Rules', icon: <GavelIcon />, path: '/rules' },
  { text: 'Jobs', icon: <WorkIcon />, path: '/jobs' },
  { text: 'Test Runs', icon: <FactCheckIcon />, path: '/test-runs' },
  { text: 'Workers', icon: <PrecisionManufacturingIcon />, path: '/workers' },
  { text: 'Scheduler', icon: <ScheduleIcon />, path: '/scheduler' },
  { text: 'Development', icon: <CodeIcon />, path: '/development' },
  { text: 'Logout', icon: <LogoutIcon />, path: '/logout' }
];

function AlertsNavItem({ pathname }: { pathname: string }) {
  return (
    <ListItem disablePadding>
      <ListItemButton component={Link} to="/alerts" selected={pathname === '/alerts'}>
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary="Alerts" />
      </ListItemButton>
    </ListItem>
  );
}

function NavigationMenu() {
  const { pathname } = useLocation();
  return (
    <>
      <List>
        <AlertsNavItem pathname={pathname} />
        {menuItems.map(({ text, icon, path }) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              component={Link}
              to={path}
              selected={pathname === path || pathname.startsWith(`${path}/`)}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </>
  );
}

function MainContent() {
  return <Outlet />;
}

export function Dashboard() {
  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3} lg={2}>
          <NavigationMenu />
        </Grid>

        <Grid item xs={12} sm={6} md={7} lg={8}>
          <MainContent />
        </Grid>
      </Grid>
    </>
  );
}
